import { render, staticRenderFns } from "./NextPreviousButtons.vue?vue&type=template&id=add121e0&"
import script from "./NextPreviousButtons.vue?vue&type=script&lang=js&"
export * from "./NextPreviousButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports